<template>
	<div class="affairs flex-wrap">
		<AuthorAffairsSection
			:taskAuthorList="taskAuthorList"
		/>
        <!-- <SimpleAuthorCalendar
			style="flex-grow: 1; margin-left: 2rem"
			:taskAuthorList="taskAuthorList"
		/> -->
    </div>
</template>

<script>
    import calendarEventsMixin from "@/mixins/calendarEvents"
    import AuthorAffairsSection from "@/components/AuthorTasks/AuthorAffairsSection";
    import SimpleAuthorCalendar from "@/components/AuthorTasks/SimpleAuthorCalendar";
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";

    export default {
        mixins: [calendarEventsMixin, databaseManager, notifier],
        name: "ListAuthorTasks",
        components: {
            AuthorAffairsSection,
            SimpleAuthorCalendar,
        },
        data() {
            return {
                taskAuthorList: [],
            }
        },
        async mounted() {
            this.taskAuthorList = await this.dbGetMyAuthorsTasks();

            // console.log(this.taskAuthorList);
        },
    }
</script>

<style lang="scss">

</style>